import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.math.hypot.js";
import { tryOnBeforeUnmount, tryOnMounted } from '@vueuse/core';
export var usePinchZoom = function usePinchZoom(_ref) {
  var container = _ref.container,
    content = _ref.content,
    onPinch = _ref.onPinch;
  var _useNuxtApp = useNuxtApp(),
    $device = _useNuxtApp.$device;
  var startX = 0;
  var startY = 0;
  var initialPinchDistance = 0;
  var pinchScale = 1;
  var originX;
  var originY;
  var reset = function reset() {
    startX = startY = initialPinchDistance = 0;
    pinchScale = 1;
  };
  var iosTouchMoveListener = function iosTouchMoveListener(e) {
    // @ts-ignore experimental
    if (e.scale !== 1) {
      e.preventDefault();
    }
  };
  var touchStartListener = function touchStartListener(e) {
    if (e.touches.length > 1) {
      container.value.style.overflow = 'hidden';
      startX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
      startY = (e.touches[0].pageY + e.touches[1].pageY) / 2;
      initialPinchDistance = Math.hypot(e.touches[1].pageX - e.touches[0].pageX, e.touches[1].pageY - e.touches[0].pageY);
    } else {
      initialPinchDistance = 0;
    }
  };
  var touchMoveListener = function touchMoveListener(e) {
    if (initialPinchDistance <= 0 || e.touches.length < 2 || !content.value) {
      return;
    }

    // @ts-ignore experimental
    if (e.scale !== 1) {
      e.preventDefault();
    }
    var pinchDistance = Math.hypot(e.touches[1].pageX - e.touches[0].pageX, e.touches[1].pageY - e.touches[0].pageY);
    originX = startX + container.value.scrollLeft;
    originY = startY + container.value.scrollTop;
    pinchScale = pinchDistance / initialPinchDistance;
    content.value.style.transform = "scale(".concat(pinchScale, ")");
    content.value.style.transformOrigin = "".concat(originX, "px ").concat(originY, "px");
  };
  var touchEndListener = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var pageCenterX, pageCenterY, centerX, centerY, px, py;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(initialPinchDistance <= 0 || !content.value)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            container.value.style.overflow = 'scroll';
            content.value.style.transform = 'none';
            content.value.style.transformOrigin = 'unset';
            // Compute the current center point in page coordinates
            pageCenterX = container.value.clientWidth / 2 + container.value.scrollLeft;
            pageCenterY = container.value.clientHeight / 2 + container.value.scrollTop; // Compute the next center point in page coordinates
            centerX = (pageCenterX - originX) / pinchScale + originX;
            centerY = (pageCenterY - originY) / pinchScale + originY; // Compute the ratios of the center point to the total scrollWidth/scrollHeight
            px = centerX / container.value.scrollWidth;
            py = centerY / container.value.scrollHeight;
            _context.next = 13;
            return onPinch(pinchScale);
          case 13:
            container.value.scrollLeft = container.value.scrollWidth * px - container.value.clientWidth / 2;
            container.value.scrollTop = container.value.scrollHeight * py - container.value.clientHeight / 2;
            reset();
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function touchEndListener() {
      return _ref2.apply(this, arguments);
    };
  }();
  function isTouchDevice() {
    var win = window;
    return !!(typeof win !== 'undefined' && ('ontouchstart' in win || win.DocumentTouch && typeof (win === null || win === void 0 ? void 0 : win.document) !== 'undefined' && (win === null || win === void 0 ? void 0 : win.document) instanceof win.DocumentTouch)) || !!(typeof (win === null || win === void 0 ? void 0 : win.navigator) !== 'undefined' && (win !== null && win !== void 0 && win.navigator.maxTouchPoints || win !== null && win !== void 0 && win.navigator.msMaxTouchPoints));
  }
  function enablePinchZoom() {
    var _container$value2, _container$value3, _container$value4;
    if (!isTouchDevice()) {
      return;
    }
    originX = startX + container.value.scrollLeft;
    originY = startY + container.value.scrollTop;
    if ($device.isIos) {
      var _container$value;
      (_container$value = container.value) === null || _container$value === void 0 ? void 0 : _container$value.addEventListener('touchmove', iosTouchMoveListener, {
        passive: false
      });
    }
    (_container$value2 = container.value) === null || _container$value2 === void 0 ? void 0 : _container$value2.addEventListener('touchstart', touchStartListener, {
      passive: true
    });
    (_container$value3 = container.value) === null || _container$value3 === void 0 ? void 0 : _container$value3.addEventListener('touchmove', touchMoveListener, {
      passive: false
    });
    (_container$value4 = container.value) === null || _container$value4 === void 0 ? void 0 : _container$value4.addEventListener('touchend', touchEndListener);
  }
  function disablePinchZoom() {
    var _container$value6, _container$value7, _container$value8;
    if ($device.isIos) {
      var _container$value5;
      (_container$value5 = container.value) === null || _container$value5 === void 0 ? void 0 : _container$value5.removeEventListener('touchmove', iosTouchMoveListener);
    }
    (_container$value6 = container.value) === null || _container$value6 === void 0 ? void 0 : _container$value6.removeEventListener('touchstart', touchStartListener);
    (_container$value7 = container.value) === null || _container$value7 === void 0 ? void 0 : _container$value7.removeEventListener('touchmove', touchMoveListener);
    (_container$value8 = container.value) === null || _container$value8 === void 0 ? void 0 : _container$value8.removeEventListener('touchend', touchEndListener);
  }
  tryOnMounted(function () {
    enablePinchZoom();
  });
  tryOnBeforeUnmount(function () {
    disablePinchZoom();
  });
  return {
    enablePinchZoom: enablePinchZoom,
    disablePinchZoom: disablePinchZoom
  };
};